import {FC, memo} from 'react'
import {SubmitButtonInterface} from '../types'

const SubmitButton: FC<SubmitButtonInterface> = memo(({
                                                          isSubmitting,
                                                          isValid,
                                                          loading,
                                                          label,
                                                          waitLabel = 'S\'il vous plaît, attendez...',
                                                      }) => (
    <button type="submit"
            className="btn btn-primary"
            disabled={isSubmitting || !isValid}
    >
        {!loading && label}
        {loading && (
            <span className="indicator-progress" style={{display: 'block'}}>
                {waitLabel}{' '}
                <span className="spinner-border spinner-border-sm align-middle ms-2" />
            </span>
        )}
    </button>
))

export {SubmitButton}
